/**
 * Look up the calibration bin covering `prob` for a given model, returning
 * the bin's sample size and reconstructed resolved-true count.
 *
 * `resolvedTrue` = how many of the bin's n forecasts resolved true,
 * reconstructed as round(accuracy*n). n=0 → accuracy null by producer
 * convention; resolvedTrue stays null and the caller's calibration line
 * hides (no placeholder row).
 *
 * @param {object|undefined} calibration — ctx.calib.calibration ({models: {[modelId]: {bins}}})
 * @param {string} modelId
 * @param {number} prob — probability in [0,1] (clamped defensively)
 * @returns {{n: number, resolvedTrue: number|null}|null}
 */
export function lookupCalibrationBin(calibration, modelId, prob) {
  const m = calibration?.models?.[modelId];
  if (!m || !Array.isArray(m.bins) || m.bins.length === 0) return null;
  const p = Math.max(0, Math.min(1, prob));
  const bin = m.bins.find((b, i) => {
    const isLast = i === m.bins.length - 1;
    return p >= b.lo && (isLast ? p <= b.hi : p < b.hi);
  });
  if (!bin) return null;
  return {
    n: bin.n,
    resolvedTrue: typeof bin.accuracy === "number" ? Math.round(bin.accuracy * bin.n) : null,
  };
}
